// extracted by mini-css-extract-plugin
export default {"list":"index_list_CzVBJ","img":"index_img_XPhaN"};